var _path, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconNutrition = function SvgIconNutrition(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41,
    clipRule: "evenodd",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-1149897233__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-1149897233__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a96555",
    d: "M42.75 3.48c.14.19.22.41.22.64v3.26H13V4.16c0-.26.1-.5.26-.69l.95-1.07a1.03 1.03 0 0 1 1.5-.05l.68.68c.4.4 1.06.4 1.47 0l.73-.73c.4-.4 1.05-.4 1.46 0l.73.73c.4.4 1.06.4 1.46 0l.73-.73c.4-.4 1.06-.4 1.46 0l.73.73c.4.4 1.06.4 1.47 0l.73-.73c.4-.4 1.05-.4 1.46 0l.73.73c.4.4 1.06.4 1.46 0l.73-.73c.4-.4 1.06-.4 1.46 0l.73.73c.4.4 1.06.4 1.46 0l.74-.73c.4-.4 1.05-.4 1.46 0l.73.73c.4.4 1.06.4 1.46 0l.64-.64a1.03 1.03 0 0 1 1.54.1l.79 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#844c3e",
    d: "M34.97 5a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm4 0a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm4 0a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm-12 0a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2896c",
    d: "M19 5a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm4 0a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm4 0a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1zM15 5a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be8263",
    d: "M43 6H13L8 42h40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a96555",
    d: "M42.53 39h-2.15a1.55 1.55 0 0 1 0-3.1c.33 0 .18-.95.15-1.28l-.06-.6c.12-.7.73-1.22 1.45-1.22h.12c.43 0 .84.19 1.12.52s.39 1.8.82 4.13c.13.7-.73 1.55-1.45 1.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5b48b",
    d: "M13 6h15v36H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be8263",
    d: "M32.5 15a3 3 0 0 0-3-3h-3a3 3 0 1 0 0 6h3a3 3 0 0 0 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.32 16.16c.42.42.99.66 1.58.66h1.04c1.23 0 2.24 1 2.24 2.24v1.04c0 .6.24 1.16.66 1.58l.73.73c.87.88.87 2.3 0 3.18-.26.25-.52.5-.73.73-.42.42-.66.99-.66 1.58v1.04c0 1.23-1 2.24-2.24 2.24H31.9c-.6 0-1.16.24-1.58.66l-.73.73c-.88.87-2.3.87-3.18 0-.25-.26-.5-.52-.73-.73-.42-.42-.99-.66-1.58-.66h-1.04c-1.23 0-2.24-1-2.24-2.24V27.9c0-.6-.24-1.16-.66-1.58l-.73-.73a2.24 2.24 0 0 1 0-3.18c.26-.25.52-.5.73-.73.42-.42.66-.99.66-1.58v-1.04c0-1.23 1-2.24 2.24-2.24h1.04c.6 0 1.16-.24 1.58-.66l.73-.73c.88-.87 2.3-.87 3.18 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 6,
    fill: "#ff9f54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 19,
    r: 1,
    fill: "#ffcd51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd51",
    d: "M28 18a6 6 0 1 0 0 12z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 3,
    fill: "#ff9f54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a96555",
    d: "M48 42H8a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3d9b2",
    d: "M19.15 11.85c-.58 0-1.06.43-1.14 1-.1.8-.86 1.36-1.7 1.27-.82-.1-1.4-.8-1.3-1.56l.3-2.32A1.5 1.5 0 0 1 16.97 9h2.51c.83 0 1.51.63 1.51 1.42s-.68 1.43-1.51 1.43h-.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3d9b2",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    d: "M39.85 24.65c1.68.08 1.8 2.78.14 4.86-.97 1.2-3.5-.12-2.4-2.02.71-1.23.86-2.87 2.26-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5b48b",
    d: "M32.5 9a3 3 0 0 0-3-3h-3a3 3 0 1 0 0 6h3a3 3 0 0 0 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bb6658",
    d: "M22.77 29H13a3 3 0 1 1 2.46-4.71.64.64 0 0 0 1.07 0A3 3 0 0 1 19 23c1.56 0 2.36.93 2.77 1.76a.64.64 0 0 0 1.05.14c.57-.55 1.33-.9 2.18-.9a3 3 0 1 1-2.23 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#713b3b",
    d: "M13.12 26.88c.52.52 1.36.52 1.87 0a2.47 2.47 0 0 1 1.96-.88H17a3 3 0 0 1 2.12.88c.52.52 1.36.52 1.87 0a2.47 2.47 0 0 1 1.96-.88h.1c.69 0 1.53.57 2.16 1.1.52.36 1.23.29 1.66-.18.5-.58 1.26-.92 2.08-.92h.1A2.95 2.95 0 0 1 32 28.95V29a3 3 0 0 1-3 3H11a3.04 3.04 0 0 1-3-3.04A2.95 2.95 0 0 1 10.95 26H11a3 3 0 0 1 2.12.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636577",
    d: "M.8 42.96a12 12 0 0 0 2.85-5.2l1.52-5.86A4 4 0 0 1 9.02 29h21.96a4 4 0 0 1 3.85 2.9l1.51 5.87a12 12 0 0 0 2.85 5.2A3 3 0 0 1 37 48H3.01a3 3 0 0 1-2.2-5.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c96",
    d: "M27 29v16H0c0-.8.32-1.54.83-2.08a12 12 0 0 0 2.9-5.03c.7-2.41 1.44-5.99 1.44-5.99A4 4 0 0 1 9.02 29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c96",
    d: "M31 45a3 3 0 0 0-3-3H10a3 3 0 1 0 0 6h18a3 3 0 0 0 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aab3bc",
    d: "M20 45a3 3 0 0 0-3-3H3a3 3 0 1 0 0 6h14a3 3 0 0 0 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d8dd",
    d: "M16 43.5c0-.83-.67-1.5-1.5-1.5h-9a1.5 1.5 0 0 0 0 3h9c.83 0 1.5-.67 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c96",
    d: "M37 43.5a1.5 1.5 0 0 0-1.5-1.5h-1a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 0 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 43.5c0-.83-.67-1.5-1.5-1.5h-3a1.5 1.5 0 0 0 0 3h3c.83 0 1.5-.67 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aab3bc",
    d: "M4.57 39.92c.81.21 1.65-.27 1.87-1.09l1.17-4.37a1.5 1.5 0 1 0-2.9-.78l-1.18 4.44a1.47 1.47 0 0 0 1.04 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d8dd",
    d: "M5.5 36.4c.82.23 1.66-.26 1.88-1.08l.23-.87a1.5 1.5 0 0 0-1.06-1.83 1.5 1.5 0 0 0-1.83 1.06l-.25.93a1.47 1.47 0 0 0 1.04 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4d62",
    d: "M32 39.5a2.5 2.5 0 0 0-2.5-2.5h-5a2.5 2.5 0 1 0 0 5h5a2.5 2.5 0 0 0 2.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4d62",
    d: "M28 39.5a2.5 2.5 0 0 0-2.5-2.5h-9a2.5 2.5 0 1 0 0 5h9a2.5 2.5 0 0 0 2.5-2.5m1-8.54A1.96 1.96 0 0 0 27.04 29H27a2 2 0 0 0-2 2v.04A1.96 1.96 0 0 0 26.96 33c1.13 0 2.04-.91 2.04-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aab3bc",
    d: "M22 30.5c0-.83-.67-1.5-1.5-1.5h-3a1.5 1.5 0 0 0 0 3h3c.83 0 1.5-.67 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 30.5a1.5 1.5 0 0 0-1.5-1.5 1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5 1.5 1.5 0 0 0 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c96",
    d: "M31 35a2 2 0 0 0-2-2h-4a2 2 0 1 0 0 4h4a2 2 0 0 0 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aab3bc",
    d: "M16.71 39a.93.93 0 0 0-.9.67A1.86 1.86 0 0 1 14 41a2 2 0 0 1 0-4 2 2 0 1 1 1.88-2.69c.1.37.45.62.83.62.76.04 1.02.05 2.29.06V35h2.29c.41 0 .77-.27.9-.67.21-.78.95-1.33 1.81-1.33a2 2 0 0 1 0 4 2 2 0 1 1-1.88 2.69.86.86 0 0 0-.83-.62c-.76-.04-1.02-.05-2.29-.06V39z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 35,
    r: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 46,
    r: 2,
    fill: "#713b3b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bb6658",
    d: "M29.1 47.79a2 2 0 1 1 1.8-3.58 3 3 0 0 1-1.79 3.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#713b3b",
    d: "m33.01 48-.01-.21a2 2 0 1 1 3.99.21H33z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconNutrition);
export default ForwardRef;